"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transpile = void 0;
const esprima_1 = require("esprima");
const generator_1 = require("./generator");
const transpile_default_1 = require("./defaults/transpile_default");
const transformer_1 = require("./transformer");
/**
 * This file collates the parser returns the generated code.
 * @param code
 */
const transpile = (code, options = transpile_default_1.default_transpile_options) => {
    options = Object.assign(Object.assign({}, transpile_default_1.default_transpile_options), options);
    try {
        let ast = options.parse_type == 'script' ? (0, esprima_1.parseScript)(code) : (0, esprima_1.parseModule)(code);
        let transformed_ast = (0, transformer_1.transformer)(ast, options);
        let out = (0, generator_1.generator)(transformed_ast, {
            object_name: options.object_name,
            additional_callees: options.additional_callees,
        });
        return out;
    }
    catch (err) {
        throw err;
    }
};
exports.transpile = transpile;
